import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { Adicional } from "src/app/models/Emisor/Adicional";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { Cupon } from "src/app/models/PlanesUsuario/Cupon";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { AdicionalType } from "src/app/shared/models/AdicionalType.enum";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { CertificadoCompraWizard } from "src/app/models/Emisor/EmisorWizardRequest";
import { CERT_PRECIOS } from 'src/app/components/configuracion-dte/mantenedor-certificados/config-certificados';
import { CertificadosDigitalesService } from "src/app/services/certificados-digitales.service";



@Component({
	selector: "app-resumen-bloque",
	templateUrl: "./resumen-bloque.component.html",
	styleUrls: ["./resumen-bloque.component.scss"],
})
export class ResumenBloqueComponent implements OnInit, OnDestroy  {
	public CERT_PRECIOS = CERT_PRECIOS; 
	public nmeses: number;
	public nmesesCorte: number;
	public nmesesAntiguo: number;
	public nmesesNuevo: number = 0;
	public tipoCertificacion: string;
	public formaPago: string;
	public codigoDescuento: string;
	public cupon: Cupon;
	public mensajeCupon: string;
	public resumenCuenta: Resumen;
	public isLoading = false;
	public pagado: boolean;
	public idEmisor = this.tokenStorage.getCompany();

	@Input() public type: string;
	@Input() public planSeleccionado: Plan;
	@Input() public certificaciones: CertificacionPrecio[];
	@Input() public planUsuario: PlanUsuario;
	@Input() public planes: Plan[];
	@Input() public planActualNuevo: Plan;
	@Input() public compraCertificado: CertificadoCompraWizard;
	
	public user: SessionUser;
	public adicionalSinMensajePDF: Adicional = new Adicional(3000, false, false, AdicionalType.MensajeSimpleFacturaPDF);
	public adicionalAccesoDTERecibido: Adicional = new Adicional(4000, false, false, AdicionalType.Recibidos);

	public planOriginal: Plan = null;
	public planNuevo: Plan = null;
	public fechaDesde: string;
	private calcSub!: Subscription;

	@Output() public actualizarResumen: EventEmitter<Resumen> = new EventEmitter<Resumen>();
	constructor(private planUsuarioService: PlanUsuarioService, private pagoService: PagoUsuarioService, private localStorage: LocalStorageService, private tokenStorage: TokenStorageService, private utilitieService: UtilitiesService, private ref: ChangeDetectorRef,private certificadoService: CertificadosDigitalesService) {
		this.user = this.tokenStorage.getUser() as SessionUser;
	}
	ngOnDestroy() {
		if(this.calcSub && this.calcSub != undefined) this.calcSub.unsubscribe();
	}
	ngOnInit(): void {
		this.calcSub = this.pagoService.triggerCalculations$.subscribe(() => {
			if (this.planSeleccionado && this.planSeleccionado.nombre.toLowerCase() == "independiente") {
				this.adicionalAccesoDTERecibido.readOnly = false;
				this.adicionalAccesoDTERecibido.message = "Valor: $4.000";
				this.adicionalAccesoDTERecibido.precio = 4000;
				this.adicionalAccesoDTERecibido.checked = false;
			}
			this.actualizarCalculos();
			this.ref.detectChanges();
		});
		this.initializeValues();
		if (this.planes != null) {
			this.planNuevo = this.planes.find((x) => x.nombre == this.planUsuario.nombrePlan && x.antiguedad == "Nuevo");
		}
		if (this.planUsuario.fechaCorte) {
			const fechaInicio = moment(this.fechaDesde);
			const fechaCorte = moment(this.planUsuario.fechaCorte);
			let diffMeses = fechaCorte.diff(fechaInicio, "months");
			this.nmesesCorte = diffMeses < 0 ? 0 : diffMeses;
		} else {
			this.nmesesCorte = 0;
		}
		if (this.nmesesCorte === 0 && this.type == "extend") {
			this.planSeleccionado = this.planNuevo;
		}
		if (!this.planUsuario.activo) {
			if (this.planUsuario.meses) this.nmeses = this.planUsuario.meses;
			if (this.planUsuario.formaPago == "free") {
				this.formaPago = "webpay";
				this.updateCertificacion("propia");
			}
		}
		this.user = this.tokenStorage.getUser() as SessionUser;
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["planSeleccionado"] && !this.planOriginal) {
			this.planOriginal = changes["planSeleccionado"].currentValue;
		}
		if (changes["compraCertificado"] && changes["compraCertificado"].currentValue) {
			if (this.compraCertificado && this.compraCertificado.comprar) {
			  this.recalcularPrecioCertificado();
			  this.actualizarCalculos();
			}
		  }
	  
	}
	calculateMeses(): void {
		if (this.type !== "extend") {
			this.nmesesNuevo = 0;
			this.nmesesAntiguo = this.nmeses;
			return;
		}
    
		if (this.nmesesCorte === 0) {
			this.nmesesAntiguo = this.nmeses;
			this.nmesesNuevo = 0;
		} else if (this.nmeses <= this.nmesesCorte) {
			this.nmesesAntiguo = this.nmeses;
			this.nmesesNuevo = 0;
		} else {
			this.nmesesAntiguo = this.nmesesCorte;
			this.nmesesNuevo = this.nmeses - this.nmesesCorte;
		}
	}
	initializeValues(): void {
		this.nmeses = 6;
		this.tipoCertificacion = "incluida";
		this.formaPago = "webpay";
		this.pagado = false;
		this.codigoDescuento = "";
		this.resumenCuenta = new Resumen();
		this.setCertFactAndCertBolToZero();
		this.checkCertFactAndCertBolToZero();
		if (this.certificaciones.every((x) => x.solicitada === false)) {
			this.tipoCertificacion = "propia";
		}
		if (this.type == "extend" || this.type == "change") this.tipoCertificacion = "propia";

		if (this.type != "extend") {
			const adicionalSinMensajePDF = this.localStorage.getAdicionales().find((x) => x.idAdicional == AdicionalType.MensajeSimpleFacturaPDF);
			const adicionalAccesoDTERecibido = this.localStorage.getAdicionales().find((x) => x.idAdicional == AdicionalType.Recibidos);

			//TODO: Obtener descripciones de los planes. Son vacíos si es que el adicional no existe.
			if (adicionalSinMensajePDF) this.adicionalSinMensajePDF = adicionalSinMensajePDF;
			else {
				this.adicionalSinMensajePDF.idEmisor = this.idEmisor;
				this.adicionalSinMensajePDF.descripcion = "En el pie de página de los PDF de los DTE, se oculta el mensaje indicando que se realizó con SimpleFactura.";
			}
			if (adicionalAccesoDTERecibido) this.adicionalAccesoDTERecibido = adicionalAccesoDTERecibido;
			else {
				this.adicionalAccesoDTERecibido.idEmisor = this.idEmisor;
				this.adicionalAccesoDTERecibido.descripcion = "Módulo de Documentos emitidos por proveedores.";
			}
		} else {
			this.adicionalSinMensajePDF.idEmisor = this.idEmisor;
			this.adicionalAccesoDTERecibido.idEmisor = this.idEmisor;
		}
		this.fechaDesde =
			this.type == "wizard" || this.type == "change" //|| this.planUsuario.formaPago == 'free'
				? new Date().toISOString()
				: new Date(this.planUsuario.fechaCaducidad).toISOString();
		// console.log("initializeValues");
		// this.actualizarCalculos();
		if (this.tipoCertificacion == "propia") {
			this.certificaciones.forEach((x) => {
				x.solicitada = false;
			});
		}
	}

	updateCupon(codigo: string) {
		this.codigoDescuento = codigo;
		if (codigo.length > 0) {
			this.planUsuarioService.getCupon(this.codigoDescuento).subscribe(
				(data) => {
					this.cupon = data;
				},
				(error) => {
					this.mensajeCupon = this.utilitieService.setErrorMessageFromArray(error.error);
					this.cupon = undefined;
				},
				() => {
					this.actualizarCalculos();
				}
			);
		} else {
			this.cupon = undefined;
			this.actualizarCalculos();
		}
	}

	updateFormaPago(forma) {
		this.formaPago = forma;
		if (forma == "free") {
			this.updateCertificacion("propia");
		} else {
			this.actualizarCalculos();
		}
	}

	updateCertificacion(tipo) {
		this.tipoCertificacion = tipo;
		if (this.nmeses >= 6) {
			this.setCertFactAndCertBolToZero();
		}
		if (this.tipoCertificacion != "propia") {
			this.formaPago = "webpay";
		} else {
			this.certificaciones.forEach((x) => {
				x.solicitada = false;
			});
		}
		this.actualizarCalculos();
	}

	updateModelCertificacion(cert) {
		cert.solicitada = !cert.solicitada;
		this.actualizarCalculos();
	}

	updateMes(meses) {
		this.nmeses = meses;
		this.calculoMeses();
		this.actualizarCalculos();
	}
	calcularAbonoUpgrade(
		fechaHoy: moment.Moment,
		fechaFinPlan: moment.Moment,
		fechaCorte: moment.Moment | null,
		precioAntiguo: number,
		precioNuevo: number
	): { abono: number, mesesAbono: number } {
		// 1. AbonoStart: primer día del próximo mes
		let abonoStart = fechaHoy.clone().add(1, 'month').startOf('month');

		// 2. El mes de corte es el último mes con precio antiguo (incluido si es válido)
		let ultimoMesAntiguo = fechaCorte && fechaCorte.isSameOrAfter(abonoStart) && fechaCorte.isBefore(fechaFinPlan)
			? fechaCorte.clone().endOf('month')
			: null;

		// Si no hay corte válido, todos los meses hasta el fin de plan (pero ojo con el último)
		if (!ultimoMesAntiguo) {
			// Si el plan termina el día 30 o el último día del mes, ese mes se cuenta.
			let fin = fechaFinPlan.clone();
			const esUltimoDia = fin.date() === fin.clone().endOf('month').date() || fin.date() === 30;
			ultimoMesAntiguo = esUltimoDia
				? fin.clone().endOf('month')
				: fin.clone().subtract(1, 'month').endOf('month');
		}

		// 3. Calcular meses con precio antiguo (incluye ambos extremos)
		let mesesAntiguo = ultimoMesAntiguo.isBefore(abonoStart) ? 0 : ultimoMesAntiguo.diff(abonoStart, 'months') + 1;

		// 4. Calcular meses con precio nuevo (si hay corte)
		let mesesNuevo = 0;
		if (fechaCorte && fechaCorte.isSameOrAfter(abonoStart) && fechaCorte.isBefore(fechaFinPlan)) {
			// Empieza en el 1 del mes siguiente al corte
			let inicioNuevo = fechaCorte.clone().add(1, 'month').startOf('month');
			// ¿El plan termina al final del mes o el día 30?
			let fin = fechaFinPlan.clone();
			const esUltimoDia = fin.date() === fin.clone().endOf('month').date() || fin.date() === 30;
			let finNuevo = esUltimoDia
				? fin.clone().endOf('month')
				: fin.clone().subtract(1, 'month').endOf('month');
			mesesNuevo = finNuevo.isBefore(inicioNuevo) ? 0 : finNuevo.diff(inicioNuevo, 'months') + 1;
		}

		let abono = (mesesAntiguo * precioAntiguo) + (mesesNuevo * precioNuevo);

		// LOG
		if (mesesNuevo > 0) {
			let inicioNuevo = fechaCorte.clone().add(1, 'month').startOf('month');
			let finNuevo = fechaFinPlan.clone();
			const esUltimoDia = finNuevo.date() === finNuevo.clone().endOf('month').date() || finNuevo.date() === 30;
			finNuevo = esUltimoDia
				? finNuevo.clone().endOf('month')
				: finNuevo.clone().subtract(1, 'month').endOf('month');
		}
		var mesesAbono = mesesAntiguo + mesesNuevo;
		return { abono, mesesAbono };
	}


	actualizarCalculos() {
		const isUpgrade =
				this.type === 'change' &&
				this.esUpgrade(this.planUsuario, this.planSeleccionado) &&
				moment().isBefore(moment(this.planUsuario.fechaCaducidad));

		let abono = 0;
		let mesesAbono = 0;
		if (isUpgrade) {
			const fechaHoy = moment();
			const fechaFinPlan = moment(this.planUsuario.fechaCaducidad);
			const fechaCorte = this.planUsuario.fechaCorte ? moment(this.planUsuario.fechaCorte) : null;
			const { abono: abonoUpgrade, mesesAbono: mesesUpgrade } = this.calcularAbonoUpgrade(
				fechaHoy,
				fechaFinPlan,
				fechaCorte,
				this.planUsuario.pagoMensual,
				this.planActualNuevo.precio
			);
			abono = abonoUpgrade;
			mesesAbono = mesesUpgrade;

			// Forzar mínimo en el slider si es necesario
			if (this.nmeses < mesesAbono) {
				this.nmeses = mesesAbono;
			}
		}
		let customResumen: any = null;
		if (this.formaPago === 'free' && this.compraCertificado?.comprar) {
			const base = this.compraCertificado.preciobase || 0;
			const garantia = this.compraCertificado.precioGarantia || 0;
			const subtotal = base + garantia;
			const iva = Math.round(subtotal * 0.19);
			const total = subtotal + iva;
			// Guardamos el resumen personalizado
			customResumen = {
				proporcional: 0,
				totalPlanes: 0,
				totalAdicionales: 0,
				totalCertificaciones: 0,
				subtotal: subtotal,
				descuento: 0,
				descuentoPorc: 0,
				neto: subtotal,
				iva: iva,
				total: total,
				totalCertificadoDigital: total,
				formaPago: this.formaPago,
			};
		}
		if (this.planSeleccionado) {
			if (this.planSeleccionado.nombre.toLowerCase() != "independiente") {
				this.adicionalAccesoDTERecibido.readOnly = true;
				this.adicionalAccesoDTERecibido.checked = true;
				this.adicionalAccesoDTERecibido.precio = 0;
				this.adicionalAccesoDTERecibido.message = "Incluído con tu plan";
			} else if (this.adicionalAccesoDTERecibido.precio != 0) {
				this.adicionalAccesoDTERecibido.readOnly = false;
				this.adicionalAccesoDTERecibido.message = "Valor: $4.000";
				this.adicionalAccesoDTERecibido.precio = 4000;
			}
			this.ref.detectChanges();
			this.isLoading = true;
			
			this.calculateMeses();
						
			const fechaDesde = this.type == 'wizard' || this.type == 'change' //|| this.planUsuario.formaPago == 'free'
			? new Date().toISOString() 
			: new Date(this.planUsuario.fechaCaducidad).toISOString();
			const totalCertificadoDigital = this.calcularTotalesCertificadoDigital();
			this.planUsuarioService.getCalculos(this.planSeleccionado.id, this.nmesesAntiguo, this.tipoCertificacion, this.codigoDescuento, 
				this.certificaciones, this.adicionalAccesoDTERecibido, this.adicionalSinMensajePDF, this.fechaDesde, 
				this.user.configured,this.planNuevo ? this.planNuevo.id : null, this.nmesesNuevo,
				totalCertificadoDigital, abono
			).subscribe((data) => {
				if (isUpgrade) {
					data.abono = abono;
					data.mesesAbono = mesesAbono;
					data.descripcionAbono =
					`Se consideró $${abono.toLocaleString('es')} como abono por el plan ${this.planUsuario.nombrePlan}`;
				}
				data.totalCertificadoDigital = totalCertificadoDigital;
				data.formaPago = this.formaPago;
				data.idPlanSf = this.planSeleccionado.id;
				data.nombrePlan = this.planSeleccionado.nombre;
				data.adicionales = [this.adicionalAccesoDTERecibido, this.adicionalSinMensajePDF];
				//TODO: data.idPlanUsuario = this.idPlanUsuario;
				data.extend = this.type == "extend";
				data.change = this.type == "change";
				data.codigoCupon = this.codigoDescuento;
				//TODO: if (this.pagado == true) data.total = this.planUsuarioPagado.total;
				data.idPlanUsuario = this.planUsuario.idPlanUsuario;
				this.resumenCuenta = data;
				data.certificaciones = this.certificaciones;
				this.calculoMeses();
				data.pagado = this.planUsuario.pagado;
				data.differenceInDays = this.calculoDiasDiferencia(data.fechaInicioProporcional, data.fechaTermino);
				this.resumenCuenta = customResumen
				? { ...data, ...customResumen }
				: data;
				this.actualizarResumen.emit(this.resumenCuenta);
				this.ref.detectChanges();
				this.isLoading = false;
			});
		}
	}
	calcularMesesAbono(fechaActual: moment.Moment, fechaFinPlan: moment.Moment): number {
		// 1. Inicio del abono: primer día del próximo mes
		let abonoStart = fechaActual.clone().add(1, 'month').startOf('month');

		// 2. Evaluar si el fin de plan es "fin de mes" o día 30, o último de febrero
		let abonoEnd: moment.Moment;
		const esUltimoFebrero = fechaFinPlan.month() === 1 && // 0-based: 1 = febrero
			fechaFinPlan.date() === fechaFinPlan.clone().endOf('month').date();

		if (
			fechaFinPlan.date() === 30 ||      // Día 30 de cualquier mes
			esUltimoFebrero                    // Último día de febrero
		) {
			abonoEnd = fechaFinPlan.clone();
		} else {
			// Otros casos: solo meses completos previos
			abonoEnd = fechaFinPlan.clone().subtract(1, 'month').endOf('month');
		}

		// 3. No hay meses de abono si abonoEnd < abonoStart
		if (abonoEnd.isBefore(abonoStart)) {
			return 0 ;
		}

		// 4. Diferencia de meses completos (incluyendo ambos extremos)
		const mesesAbono = abonoEnd.diff(abonoStart, 'months') + 1;
		return mesesAbono > 0 ? mesesAbono : 0;
	}
	calculoDiasDiferencia(fechaInicioProporcional: any, fechaTermino: any): number {
		const fechaInicio = new Date(fechaInicioProporcional);
		const fechaFin = new Date(fechaTermino);

		if (!fechaInicio || !fechaFin || isNaN(fechaInicio.getTime()) || isNaN(fechaFin.getTime())) {
			return 0;
		}
		const fechaInicioSinHoras = new Date(fechaInicio.setHours(0, 0, 0, 0));
		const fechaTerminoSinHoras = new Date(fechaFin.setHours(0, 0, 0, 0));
		const diferenciaEnMilisegundos = fechaTerminoSinHoras.getTime() - fechaInicioSinHoras.getTime();
		const diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

		return diferenciaEnDias;
	}

	// calculoMeses() {
	// 	if (this.certificaciones && this.tipoCertificacion != "propia") {
	// 		if (this.nmeses == 0) this.nmeses = 6;
	// 		else if (this.nmeses >= 6) {
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 33).valor = 0;
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 39).valor = 0;
	// 			this.tipoCertificacion = "incluida";
	// 		} else {
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 33).valor = 30000;
	// 			this.certificaciones.find((x) => x.codigoPrincipal == 39).valor = 15000;
	// 			this.tipoCertificacion = "agregar";
	// 		}
	// 	}
	// }
	get isIndependiente(): boolean {
		return this.planSeleccionado?.nombre?.toLowerCase() === "independiente";
	}

	calculoMeses() {
		if (!this.certificaciones || this.tipoCertificacion === "propia") {
			return;
		}

		if (this.isIndependiente) {
			// Lógica para planes "independiente"
			if (this.nmeses < 12) {
				// Menos de 12 meses
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 45000;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 30000;
				this.tipoCertificacion = "agregar";
			} else {
				// 12 meses o más
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 0;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 0;
				this.tipoCertificacion = "incluida";
			}
		} else {
			// Lógica para otros planes
			if (this.nmeses < 6) {
				// Menos de 6 meses
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 45000;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 30000;
				this.tipoCertificacion = "agregar";
			} else {
				// 6 meses o más
				this.certificaciones.find((x) => x.codigoPrincipal === 33).valor = 0;
				this.certificaciones.find((x) => x.codigoPrincipal === 39).valor = 0;
				this.tipoCertificacion = "incluida";
			}
		}
	}

	setCertFactAndCertBolToZero(): void {
		if (this.certificaciones) {
			let certFact = this.certificaciones.find((x) => x.codigoPrincipal === 33);
			certFact.valor = 0;

			let certBol = this.certificaciones.find((x) => x.codigoPrincipal === 39);
			certBol.valor = 0;

			this.ref.detectChanges();
		}
	}

	checkCertFactAndCertBolToZero(): void {
		if (this.certificaciones) {
			let certFact = this.certificaciones.find((x) => x.codigoPrincipal === 33);
			certFact.solicitada = true;

			let certBol = this.certificaciones.find((x) => x.codigoPrincipal === 39);
			certBol.solicitada = true;

			this.ref.detectChanges();
		}
	}

	onChangeDuracion(): void {      
		this.recalcularPrecioCertificado();
		this.actualizarCalculos();                    
	}
	  
	onCheckBoxGarantia(): void {
		this.recalcularPrecioCertificado();
		this.actualizarCalculos();
	}

	private recalcularPrecioCertificado(): void {
		const duracion = this.compraCertificado.duracion;
		const garantia = this.compraCertificado.garantia;

		if (!duracion) {
			this.compraCertificado.preciobase = 0;
			this.compraCertificado.precioGarantia = 0;
			this.compraCertificado.total = 0;
			return;
		}
		this.certificadoService.getTarifasCertificado().subscribe({
			next: (data) => {
				const precioCert = data.find(
					t => t.nombreProducto == "Certificado Digital"&& t.anios === duracion
				);
				const precioGarantia = data.find(
					t => t.nombreProducto.toLowerCase().includes('garantía') && t.anios === duracion
				);

				this.compraCertificado.preciobase = precioCert ? precioCert.precio : 0;
				this.compraCertificado.precioGarantia = (garantia && precioGarantia) ? precioGarantia.precio : 0;
				this.compraCertificado.total = this.compraCertificado.preciobase + this.compraCertificado.precioGarantia;
				this.ref.detectChanges();
				this.actualizarCalculos();
			},
			error: () => {
				this.compraCertificado.preciobase     = 0;
				this.compraCertificado.precioGarantia = 0;
				this.compraCertificado.total          = 0;
				this.ref.detectChanges();
				this.actualizarCalculos();
			}
		});
	}

	private calcularTotalesCertificadoDigital(): number {
		if (this.compraCertificado?.comprar) {
			const subtotal = (this.compraCertificado.preciobase || 0) + (this.compraCertificado.precioGarantia || 0);
			this.compraCertificado.total = Math.round(subtotal);
			return this.compraCertificado.total;
		}
		return 0;
	}

	public eliminarCertificadoDigital(): void {
		this.compraCertificado.comprar = false;
		this.compraCertificado.duracion = null;
		this.compraCertificado.garantia = false;
		this.compraCertificado.preciobase = 0;
		this.compraCertificado.precioGarantia = 0;
		this.compraCertificado.total = 0;
		this.actualizarCalculos();
	}
	private esUpgrade(planActual: PlanUsuario, planNuevo: Plan): boolean {
		// Puede ser por precio o por jerarquía
		return planNuevo && planActual && (planNuevo.precio > planActual.pagoMensual);
	}

}
